import LoginForm from './LoginForm';
import { useStep } from '../Base/StepContext';
import pattern from '../../pattern.svg';
import { useEffect, useState } from 'react';
import LoadingSpinner from '../ReusableComponents/LoadingSpinner';
import AlreadyLoggedIn from './AlreadyLoggedIn';
import CreateAccountForm from './CreateAccountForm';
import AuthenticationService from '../../Core/Services/AuthenticationService';
import PaymentService, { addVat } from '../../Core/Services/PaymentService';
import { useTranslation } from 'react-i18next';
import { useGlobal } from '../../Core/GlobalState/Store';
import BookingSummary from '../ReusableComponents/BookingSummary';

export default function UserDetailsPage() {
  const { handleNext, activeStep, totalSteps } = useStep();
  const [showLogin, setShowLogin] = useState(false);
  const { t } = useTranslation();

  const {
    user,
    setUser,
    room,
    pluginUrl,
    loading,
    setLoading,
    date,
    setCvr,
  } = useGlobal();


  // TODO we need to change this if we use daily prices.
  const firstMonthPrice = addVat(
    PaymentService.calculateProratedAmount(room, date)
  );

  useEffect(() => {
    const checkToken = async () => {
      setLoading(true);
      const userInfo = await AuthenticationService.validateToken();
      // Only update if userInfo is different to avoid infinite loop
      if (!user || user.email !== userInfo?.email) {
        setUser(userInfo);
      }
      setLoading(false);
    };
    checkToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      className="w-full flex flex-col " // !border-solid !border-l !border-r border-gray-300 border-1
     /*  style={{
        backgroundImage: `url(${pluginUrl + pattern})`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'top right',
      }} */
    >
      <div className="mb-2 h-[180px] md:h-[320px] text-center flex flex-col justify-center items-center">
        <div
          className="text-uppercase font-medium text-sm"
          style={{ color: '#BF4B30' }}
        >
          {t('header_current_step', { currentStep: activeStep + 1, totalSteps })}
        </div>
        <h1 className="text-2xl md:text-5xl font-bold">{t('your_details')}</h1>
      </div>
      <div className="grid grid-cols-12 py-2 md:py-0">
        {loading && <LoadingSpinner />}
        <div className="col-span-12 md:col-span-7 md:px-8 md:mx-auto w-full">
          {!loading && showLogin && (
            <LoginForm
              setUser={setUser}
              handleNext={handleNext}
              setShowLogin={setShowLogin}
            />
          )}
          {!loading && !showLogin && !user && (
            <CreateAccountForm
              handleNext={handleNext}
              setUser={setUser}
              setCvr={setCvr}
              setShowLogin={setShowLogin}
            />
          )}
          {!loading && user && user.email && (
            <AlreadyLoggedIn user={user} setUser={setUser} />
          )}
        </div>

        <div className="col-span-12 md:col-span-5 ">
          <BookingSummary firstMonthPrice={firstMonthPrice} showAutoRenew />
        </div>
      </div>
    </div>
  );
}
